document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".aesWaveTable").forEach(table => {
    let stripe = -1;
    const activeRowspans = {};

    table.querySelectorAll("tr").forEach(tr => {
      // check if any rowspans are still active in this row
      const continuingRowspan = Object.values(activeRowspans).some(v => v > 0);

      if (!continuingRowspan) {
        stripe++; // new stripe only if no rowspan is continuing
      }

      // apply stripe only to "odd" groups
      if (stripe % 2 === 1) {
        tr.classList.add("striped");
      }

      // update rowspan tracker (now includes <td> and <th>)
      tr.querySelectorAll("td, th").forEach((cell, idx) => {
        if (cell.hasAttribute("rowspan")) {
          activeRowspans[idx] = parseInt(cell.getAttribute("rowspan"), 10);
        }
      });

      // decrement rowspan counters
      Object.keys(activeRowspans).forEach(k => {
        activeRowspans[k]--;
        if (activeRowspans[k] <= 0) delete activeRowspans[k];
      });
    });
  });
});